import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Form } from 'antd';
import { LayersNodeModel } from '../../models';
import { PanelSwitch } from '../../../custom_shared/components';
import { LayoutRendererProps } from '../../componentTypes';
import LayerRenderer from './LayerRenderer';
import './LayersLayoutRenderer.less';

interface Props extends LayoutRendererProps {
    node: LayersNodeModel;
}

const LayersLayoutRenderer: React.FC<Props> = (props: Props) => {
    const { node, formKey, form, onValuesChange, getComponentRows } = props;

    const containerRef = React.useRef<HTMLDivElement>(null);

    const layerRefs = React.useRef<Map<string, React.RefObject<HTMLDivElement>>>(new Map());

    const addLayerRef = React.useCallback((layerId: string, layerRef: React.RefObject<HTMLDivElement>) => {
        layerRefs.current.set(layerId, layerRef);
    }, []);

    return (
        <>
            <PanelSwitch
                panelsRefs={layerRefs}
                containerRef={containerRef}
                options={node.layers.map(layer => ({ id: layer.id, label: layer.name }))}
            />

            <div ref={containerRef} className="layers-layout-renderer-container custom-scroll">
                <Form id={node.id} key={formKey} form={form} onValuesChange={onValuesChange}>
                    <div className="layers-layout-content">
                        {node.layers.map(layer => (
                            <LayerRenderer
                                key={layer.id}
                                node={node}
                                layer={layer}
                                getComponentRows={getComponentRows}
                                addLayerRef={addLayerRef}
                            />
                        ))}
                    </div>
                </Form>
            </div>
        </>
    );
};

export default observer(LayersLayoutRenderer);
